import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const Article = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12715"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12715)">
          <rect
            x="-39"
            y="-1.43146"
            width="194"
            height="111.863"
            rx="6.25806"
            fill="#FFCBCB"
          />
          <path
            d="M17.3308 74.3415V35.4405C17.3308 34.5025 17.7034 33.603 18.3666 32.9398C19.0298 32.2766 19.9293 31.904 20.8673 31.904H95.1329C96.0708 31.904 96.9703 32.2766 97.6335 32.9398C98.2968 33.603 98.6693 34.5025 98.6693 35.4405V74.3415H17.3308Z"
            fill="#66E1FF"
          />
          <path
            d="M79.2188 31.904H20.8673C19.9293 31.904 19.0298 32.2766 18.3666 32.9398C17.7034 33.603 17.3308 34.5025 17.3308 35.4405V74.3415H36.7813L79.2188 31.904Z"
            fill="#C2F3FF"
          />
          <path
            d="M17.3308 74.3415H98.6693V81.4144C98.6693 82.3523 98.2968 83.2518 97.6335 83.9151C96.9703 84.5783 96.0708 84.9509 95.1329 84.9509H20.8673C19.9293 84.9509 19.0298 84.5783 18.3666 83.9151C17.7034 83.2518 17.3308 82.3523 17.3308 81.4144V74.3415Z"
            fill="white"
          />
          <path
            d="M91.5964 31.904H95.1329C96.0708 31.904 96.9703 32.2766 97.6335 32.9398C98.2968 33.603 98.6693 34.5025 98.6693 35.4404V81.4144C98.6693 82.3523 98.2968 83.2518 97.6335 83.9151C96.9703 84.5783 96.0708 84.9509 95.1329 84.9509H20.8673C19.9293 84.9509 19.0298 84.5783 18.3666 83.9151C17.7034 83.2518 17.3308 82.3523 17.3308 81.4144V35.4404C17.3308 34.5025 17.7034 33.603 18.3666 32.9398C19.0298 32.2766 19.9293 31.904 20.8673 31.904H24.4037"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.3179 95.5602H75.6825"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.3047 84.9508H52.6953V95.5602H63.3047V84.9508Z"
            fill="#E3E3E3"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M84.5969 22.0362H31.4033V73.6652H84.5969V22.0362Z"
            fill="white"
          />
          <path
            d="M84.5234 22.1096H31.4766V17.7583C31.4766 16.8203 31.8492 15.9208 32.5124 15.2576C33.1756 14.5944 34.0751 14.2218 35.013 14.2218H80.987C81.9249 14.2218 82.8244 14.5944 83.4876 15.2576C84.1508 15.9208 84.5234 16.8203 84.5234 17.7583V22.1096Z"
            fill="white"
          />
          <path
            d="M31.4766 68.8332V17.7583C31.4766 16.8203 31.8492 15.9208 32.5124 15.2576C33.1756 14.5944 34.0751 14.2218 35.013 14.2218H80.987C81.9249 14.2218 82.8244 14.5944 83.4876 15.2576C84.1508 15.9208 84.5234 16.8203 84.5234 17.7583V68.8332"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.9272 52.5476H40.3178C39.8488 52.5476 39.3991 52.7339 39.0675 53.0655C38.7359 53.3971 38.5496 53.8469 38.5496 54.3158V64.9252C38.5496 65.3942 38.7359 65.8439 39.0675 66.1755C39.3991 66.5071 39.8488 66.6934 40.3178 66.6934H50.9272C51.3961 66.6934 51.8459 66.5071 52.1775 66.1755C52.5091 65.8439 52.6954 65.3942 52.6954 64.9252V54.3158C52.6954 53.8469 52.5091 53.3971 52.1775 53.0655C51.8459 52.7339 51.3961 52.5476 50.9272 52.5476Z"
            fill="#66E1FF"
          />
          <path
            d="M52.1791 53.0606C52.0146 52.8965 51.8193 52.7664 51.6045 52.6778C51.3897 52.5892 51.1595 52.5438 50.9272 52.5443H40.3178C39.8488 52.5443 39.3991 52.7305 39.0675 53.0622C38.7359 53.3938 38.5496 53.8435 38.5496 54.3125V64.9219C38.5491 65.1542 38.5945 65.3844 38.6831 65.5992C38.7717 65.814 38.9018 66.0092 39.0659 66.1738L52.1791 53.0606Z"
            fill="#C2F3FF"
          />
          <path
            d="M50.9272 52.5476H40.3178C39.8488 52.5476 39.3991 52.7339 39.0675 53.0655C38.7359 53.3971 38.5496 53.8469 38.5496 54.3158V64.9252C38.5496 65.3942 38.7359 65.8439 39.0675 66.1755C39.3991 66.5071 39.8488 66.6934 40.3178 66.6934H50.9272C51.3961 66.6934 51.8459 66.5071 52.1775 66.1755C52.5091 65.8439 52.6954 65.3942 52.6954 64.9252V54.3158C52.6954 53.8469 52.5091 53.3971 52.1775 53.0655C51.8459 52.7339 51.3961 52.5476 50.9272 52.5476Z"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.7358 56.4899H77.0609"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.7358 62.748H77.0609"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.3308 74.3415H98.6693"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.4766 22.1095H84.5234"
            stroke="#191919"
            strokeWidth="1.17339"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.0484 29.8588C47.0484 29.4267 47.3986 29.0765 47.8306 29.0765H104.153C104.585 29.0765 104.935 29.4267 104.935 29.8588V42.9225C104.935 43.3546 104.585 43.7048 104.153 43.7048H47.8306C47.3986 43.7048 47.0484 43.3546 47.0484 42.9225V29.8588Z"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.56452"
          />
          <path
            d="M50.4849 34.047V33.28C50.4849 33.0765 50.5657 32.8814 50.7095 32.7376C50.8534 32.5938 51.0485 32.5129 51.2519 32.5129H56.6211C56.8245 32.5129 57.0196 32.5938 57.1634 32.7376C57.3073 32.8814 57.3881 33.0765 57.3881 33.28V34.047"
            stroke="#1E1E1E"
            strokeWidth="1.56452"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M53.9363 32.5129V39.4161"
            stroke="#1E1E1E"
            strokeWidth="1.56452"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M52.4026 39.4161H55.4707"
            stroke="#1E1E1E"
            strokeWidth="1.56452"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.4763 39.7998H66.2943"
            stroke="#1E1E1E"
            strokeWidth="1.56452"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
